import * as React from 'react';
import type { SVGProps } from 'react';

export const WindowsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 4V28H32V4H0ZM24 15H17V6H24V15ZM15 6V15H8V6H15ZM6 26H2V6H6V26ZM8 17H15V26H8V17ZM17 26V17H24V26H17ZM30 26H26V6H30V26Z"
      fill="currentColor"
    />
  </svg>
);
